import script from "./FooterAllezchantez.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterAllezchantez.vue?vue&type=script&setup=true&lang=js"

import "./FooterAllezchantez.vue?vue&type=style&index=0&id=44a0fe6d&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44a0fe6d"]])

export default __exports__